import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawMapIcon from "./RawMapIcon.svg.jsx";

const MapIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawMapIcon} {...props} />;
});

export default MapIcon;
